export default function date_format(date){
    date = new Date(date);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
}